import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import type { RootState } from '@/redux/common/store';

interface AuthGuardProps {
  element: React.ReactElement;
  requiredPermissions?: string[];
}

const AuthGuard: React.FC<AuthGuardProps> = ({ element, requiredPermissions = [] }) => {
  const { isAuthenticated, permissions } = useSelector((state: RootState) => state.sessionState);
  const location = useLocation();

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (requiredPermissions.length > 0) {
    const hasAll = permissions.includes('all_data') || requiredPermissions.every((p) => permissions.includes(p));
    if (!hasAll) {
      return <Navigate to="/" replace />;
    }
  }

  return element;
};

export default AuthGuard;
